import React, { useCallback, useState } from "react";
import { ThemeProvider } from "styled-components";
import { arrayOf, func, oneOf, string } from "prop-types";

import { RADIO_INPUT_GROUP_THEMES } from "./radioInputGroupThemes";
import * as S from "./styled";

const RadioInputGroup = ({
  className,
  customName,
  customOptionLabel,
  customOptionTrigger,
  name,
  onChange,
  options,
  theme
}) => {
  const [activeOption, setActiveOption] = useState(null);
  const [customOption, setCustomOption] = useState(null);

  const optionChangeHandler = useCallback(
    e => {
      const { value } = e.target;

      if (
        activeOption === customOptionTrigger &&
        value !== customOptionTrigger
      ) {
        setCustomOption(null);
        onChange(customName, null);
      }

      setActiveOption(value);
      onChange(name, value);
    },
    [setActiveOption, setCustomOption, onChange, name, customName, activeOption]
  );

  const customOptionChangeHandler = useCallback(
    e => {
      const { value } = e.target;

      setCustomOption(value);
      onChange(customName, value);
    },
    [setCustomOption, onChange]
  );

  return (
    <ThemeProvider theme={{ theme }}>
      <S.RadioInputGroupContainer className={className}>
        {options.map(value => (
          <S.RadioInputUnitContainer key={value}>
            <S.RadioInput
              id={value}
              name={name}
              onChange={optionChangeHandler}
              value={value}
            />
            <S.RadioInputLabel htmlFor={value}>{value}</S.RadioInputLabel>
          </S.RadioInputUnitContainer>
        ))}

        <S.CustomOptionContainer>
          {activeOption === customOptionTrigger && (
            <>
              <S.HiddenLabel htmlFor="custom-option">
                {customOptionLabel}
              </S.HiddenLabel>
              <S.TextInput
                id="custom-option"
                name={customName}
                onChange={customOptionChangeHandler}
                value={customOption || ""}
              />
            </>
          )}
        </S.CustomOptionContainer>
      </S.RadioInputGroupContainer>
    </ThemeProvider>
  );
};

RadioInputGroup.propTypes = {
  className: string,
  customName: string.isRequired,
  customOptionLabel: string,
  customOptionTrigger: string.isRequired,
  name: string.isRequired,
  onChange: func.isRequired,
  options: arrayOf(string).isRequired,
  theme: oneOf(Object.values(RADIO_INPUT_GROUP_THEMES))
};

RadioInputGroup.defaultProps = {
  className: "",
  customOptionLabel: "Enter custom option",
  theme: RADIO_INPUT_GROUP_THEMES.default
};

export default RadioInputGroup;
